// extracted by mini-css-extract-plugin
export var container = "_rx-0";
export var table = "_rx-2";
export var tableWrapper = "_rx-1";